import { Redirect } from './checkoutState';

const getData = (parameters: { name: string; value: string }[]) =>
  Object.fromEntries(parameters.map(({ name, value }) => [name, value]));

const redirect = ({ method, url, parameters }: Redirect) => {
  const data = parameters && getData(parameters);
  if (method === 'GET') {
    window.location.href = data ? `${url}?${new URLSearchParams(data).toString()}` : url;
  } else if (method === 'POST') {
    const form = document.createElement('form');
    form.method = method;
    form.action = url;
    if (data) {
      Object.entries(data).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = value;
        form.appendChild(input);
      });
    }
    document.body.appendChild(form);
    form.submit();
  }
};

export default redirect;
